// src/pages/blog/BlogListingPage.js
import React from 'react';
import { BookOpen, Edit3, Calendar, User } from 'lucide-react';
// --- IMPORT THE ACTUAL POSTS DATA ---
import { posts as allPostsData } from './postsData'; // Adjust path if needed

// Convert the object of posts into an array for mapping
const blogPostsArray = Object.values(allPostsData);

const BlogListingPage = ({ onNavigate }) => {
  const handlePostClick = (e, slug) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(`/blog/${slug}`);
    } else {
      console.warn("onNavigate prop not provided to BlogListingPage. Cannot navigate.");
      // Potentially fallback to window.location.href or direct react-router navigate
    }
  };

  return (
    <div className="bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <header className="text-center mb-12 sm:mb-16">
          <BookOpen className="h-12 w-12 sm:h-16 sm:w-16 mx-auto mb-4 text-blue-600 dark:text-blue-400" />
          <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 dark:text-white">
            The TabDivider <span className="text-blue-600 dark:text-blue-400">Blog</span>
          </h1>
          <p className="mt-4 text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Your source for tips on <strong className="text-gray-700 dark:text-gray-200">easy bill splitting</strong>, managing group expenses, and making the most of TabDivider.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPostsArray.map((post) => ( // Use blogPostsArray
            <article
              key={post.id} // Use post.id from your data
              className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden flex flex-col group hover:shadow-2xl transition-shadow duration-300"
            >
              <a
                href={`/blog/${post.slug}`}
                onClick={(e) => handlePostClick(e, post.slug)} // Use post.slug
                className="block"
                aria-label={`Read more about ${post.title}`}
              >
                {post.imageUrl ? (
                    <img
                        src={post.imageUrl}
                        alt={`Featured image for ${post.title}`}
                        className="w-full h-56 object-cover group-hover:opacity-90 transition-opacity duration-300"
                        loading="lazy"
                    />
                ) : (
                    <div className="w-full h-56 bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                        <Edit3 className="w-16 h-16 text-gray-400 dark:text-gray-500" />
                    </div>
                )}
              </a>
              <div className="p-6 flex-grow flex flex-col">
                <div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-blue-600 dark:text-blue-400">
                    {post.category}
                  </span>
                  <h2 className="mt-2 text-xl sm:text-2xl font-semibold text-gray-900 dark:text-white line-clamp-2">
                    <a
                      href={`/blog/${post.slug}`}
                      onClick={(e) => handlePostClick(e, post.slug)}
                      className="hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200"
                      aria-label={`Read more about ${post.title}`}
                    >
                      {post.title}
                    </a>
                  </h2>
                  <p className="mt-3 text-sm sm:text-base leading-relaxed text-gray-600 dark:text-gray-300 flex-grow line-clamp-3">
                    {post.excerpt || 'Read more to find out...'}
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
                  <div className="flex items-center text-xs text-gray-500 dark:text-gray-400">
                    {post.date && <>
                        <Calendar className="h-4 w-4 mr-1.5" />
                        <span>{post.date}</span>
                        {post.author && <span className="mx-2">|</span>}
                    </>}
                    {post.author && <>
                        <User className="h-4 w-4 mr-1.5" />
                        <span>By {post.author}</span>
                    </>}
                  </div>
                  <a
                    href={`/blog/${post.slug}`}
                    onClick={(e) => handlePostClick(e, post.slug)}
                    className="mt-4 inline-block text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline group-hover:text-blue-700 dark:group-hover:text-blue-300"
                  >
                    Read More →
                  </a>
                </div>
              </div>
            </article>
          ))}
           {blogPostsArray.length === 0 && (
            <p className="md:col-span-2 lg:col-span-3 text-center text-gray-500 dark:text-gray-400 py-10">
                No blog posts available yet. Check back soon!
            </p>
           )}
        </div>
      </div>
    </div>
  );
};

export default BlogListingPage;